import { PageHeader } from "@shared/components/PageHeader";
import {
  IntegrationCardGrid,
  IntegrationCardConfig,
} from "@features/ix/shared/IntegrationCardGrid";
import React from "react";
import {
  CreditCard,
  FileText,
  Mail,
  MessageSquare,
  Receipt,
} from "lucide-react";

// const GENERAL_INTEGRATION_CARDS: IntegrationCardConfig[] = [
//   {
//     title: "Gmail",
//     description:
//       "Connects SMART360 with Gmail to send and manage automated emails and notifications.",
//     status: "not_connected",
//     icon: Mail,
//     comingSoon: true,
//     connectPath: "/integration-hub/general-integration/gmail/connect",
//     configurePath: "/integration-hub/general-integration/gmail/configure",
//     detailsPath: "/integration-hub/general-integration/gmail/details",
//   },
//   {
//     title: "Slack",
//     description:
//       "Integrates SMART360 with Slack for real-time alerts, updates, and team communication.",
//     status: "not_connected",
//     icon: MessageSquare,
//     comingSoon: true,
//     connectPath: "/integration-hub/general-integration/slack/connect",
//     configurePath: "/integration-hub/general-integration/slack/configure",
//     detailsPath: "/integration-hub/general-integration/slack/details",
//   },
// ];

const GeneralIntegrationLanding = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="General Integrations"
        subtitle="Utility-wide supporting services for alerts, APIs, webhooks, and notification orchestration."
      />
      <IntegrationCardGrid cards={[]} />
    </div>
  );
};

export default GeneralIntegrationLanding;
